// Packages and components
import React from 'react';
import { Box } from 'grommet';
import { Edit } from 'grommet-icons';
import SHDButton from '@ui/Button/SHDButton';
import SHDHeading from '@ui/Heading/SHDHeading';
import SHDModalContainer from '@ui/ModalContainer/SHDModalContainer';
import SHDText from '@ui/Text/SHDText';

// Types and interfaces
import { GameStatus, GameActions } from './schedule.d';
import type { GameActionSheetProps } from './schedule.d';
import { getFormattedScheduleDate } from '@helpers/dateUtils';

const GameActionSheet: React.FC<GameActionSheetProps> = ({
  game,
  status,
  onClick,
  isScoringLink,
}) => {
  const scheduleDateTime = getFormattedScheduleDate(game.scheduleTsStart);
  const isVBorBBSB = ['volleyball', 'bbsb'].includes(game.sportType);
  return (
    <SHDModalContainer>
      <Box margin={{ bottom: 'xlarge' }} gap="xxsmall">
        <SHDHeading level={3} color="black" formatCasing={false}>
          {game?.scoreOurName} vs {game?.scoreOpponentName}
        </SHDHeading>

        <Box direction="row" justify="start" align="center" gap="xxsmall">
          {status === GameStatus.STARTED ? (
            <SHDText style="subhead" color="dk-red">
              LIVE
            </SHDText>
          ) : (
            <SHDText margin={{ bottom: 'small' }} color="gray-900-alpha-60">
              Scheduled for {scheduleDateTime}
            </SHDText>
          )}

          {status !== GameStatus.ENDED && (
            <Edit
              size="14px"
              onClick={() => onClick?.(GameActions.EDIT_GAME, game)}
            />
          )}
        </Box>
      </Box>

      <Box gap="xsmall">
        {status !== GameStatus.ENDED && !isScoringLink && (
          <SHDButton
            primary
            label="Go live"
            // @note: (NKS 2025-04-15)
            // label={
            //   status === GameStatus.SCHEDULED ||
            //   status === GameStatus.SCHEDULED_AND_BROADCAST_OR_SCORING
            //     ? 'Go live'
            //     : 'This team is already live'
            // }
            // disabled={
            //   status !== GameStatus.SCHEDULED &&
            //   status !== GameStatus.SCHEDULED_AND_BROADCAST_OR_SCORING
            // }
            onClick={() => {
              onClick && onClick(GameActions.GO_LIVE, game);
            }}
          />
        )}

        <SHDButton
          secondary
          label={
            status === GameStatus.SCHEDULED ||
            status === GameStatus.SCHEDULED_AND_BROADCAST_OR_SCORING
              ? 'Start scoring'
              : 'Resume scoring'
          }
          onClick={() => {
            onClick &&
              onClick(
                status === GameStatus.SCHEDULED ||
                  status === GameStatus.SCHEDULED_AND_BROADCAST_OR_SCORING
                  ? GameActions.START_SCORING
                  : GameActions.RESUME_SCORING,
                game
              );
          }}
        />

        {status === GameStatus.SCHEDULED && isVBorBBSB && (
          <SHDButton
            secondary
            label="Set line up"
            onClick={() => onClick && onClick(GameActions.SET_LINEUP, game)}
          />
        )}

        {(status === GameStatus.STARTED || status === GameStatus.TIMEOUT) && (
          <SHDButton
            warning
            label="End game"
            onClick={() => onClick && onClick(GameActions.END_GAME, game)}
          />
        )}
      </Box>
    </SHDModalContainer>
  );
};

export default GameActionSheet;
